export default {"src":"/developer/_next/static/media/vk.01a1b8ba.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};